import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiResponse } from "../core/models/api-response.model";

@Injectable({ providedIn: 'root' })
export class AgreementService {

    private http = inject(HttpClient);
    private API_URL_PREFIX: string = environment.apiURL + '/admin/plan-agreement';
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    addNewAgreement(payload: any): Observable<ApiResponse> {
        return this.http.post(this.API_URL_PREFIX, payload, this.httpOptions);
    };

    getAllAgreement(): Observable<ApiResponse> {
        return this.http.get(this.API_URL_PREFIX, this.httpOptions)
    };

    findAgreementById(id: number | string | null): Observable<ApiResponse> {
        return this.http.get(this.API_URL_PREFIX + `/${id}`, this.httpOptions)
    };

    updateAgreement(id: number | string | null, payload: any): Observable<ApiResponse> {
        return this.http.put(this.API_URL_PREFIX + `/${id}`, payload, this.httpOptions)
    };

    removeAgreement(id: number | string | null): Observable<ApiResponse> {
        return this.http.delete(this.API_URL_PREFIX + `/${id}`, this.httpOptions)
    };

    previewAgreement(id: number | string | null): Observable<Blob> {
        return this.http.get(`${this.API_URL_PREFIX}/pdf-preview/${id}`, {
            responseType: 'blob',
        });
    }
    getAgreementShortCode() {
        return this.http.get(environment.apiURL + '/admin/p-d-f-shortcode', this.httpOptions)
    }

}